<script setup lang="ts">
const props = defineProps({
    showCloseButton: {
        type: Boolean,
        default: true
    },
    displaySwipeRight: {
        type: Boolean,
        default: false
    },
    displaySwipeLeft: {
        type: Boolean,
        default: false
    },
    isButtonAbsolute: {
        type: Boolean,
        default: false
    }
})

const emits = defineEmits(['closePreview', 'swipeToTheLeft', 'swipeToTheRight'])

const emitAppropriateEvent = () => {
    if (props.displaySwipeLeft) {
        emits('swipeToTheLeft')
    } else if (props.displaySwipeRight) {
        emits('swipeToTheRight')
    } else {
        emits('closePreview')
    }
}
</script>

<template>
    <div>
        <ChargemapB2CButton
            v-if="showCloseButton"
            type="secondary"
            size="medium"
            custom="less-padding"
            :class="isButtonAbsolute ? 'absolute-action' : 'action'"
            @click="emitAppropriateEvent"
        >
            <IconChevronLeft v-if="displaySwipeRight" />
            <IconChevronRight v-else-if="displaySwipeLeft" />
            <IconCross v-else />
        </ChargemapB2CButton>
        <slot />
    </div>
</template>

<style lang="scss" scoped>
.absolute-action {
    @apply top-4 right-4 z-10;
    position: absolute !important;

    svg {
        @apply h-4;
    }
}

.action {
    @apply top-4 right-4 z-10;
    position: fixed !important;

    svg {
        @apply h-4;
    }
}
</style>
